import React, { FunctionComponent, ReactNode } from 'react';
import { TimelineEntry as TimelineEntryType } from '../../../../types/__generated__';
import { Body } from './Body';
import { Footer } from './Footer';
import { Header } from './Header';

import styles from '../Timeline.scss';

export interface TimelineEntryProps {
  timelineEntry: TimelineEntryType;
  avatarUrl?: string;
  postedBy?: ReactNode;
  onDeleteEntry?: (id: string) => void;
}

const TimelineEntry: FunctionComponent<TimelineEntryProps> = ({
  timelineEntry,
  avatarUrl,
  postedBy,
  onDeleteEntry,
  children,
}) => {
  return (
    <div className={styles.timeline}>
      {children ? (
        children
      ) : (
        <>
          <Header
            timelineEntry={timelineEntry}
            avatarUrl={avatarUrl}
            postedBy={postedBy}
            onDeleteEntry={onDeleteEntry}
          />
          <Body timelineEntry={timelineEntry} />
          <Footer timelineEntry={timelineEntry} />
        </>
      )}
    </div>
  );
};
TimelineEntry.displayName = 'TimelineEntry';

export default TimelineEntry;
